const SLASH_COMMAND_SPLIT_RE = /^(\s*)(\/[a-z0-9]+(?:-[a-z0-9]+)*)/;

export interface SplitSlashCommand {
   before: string;
   token: string;
   after: string;
}

export const splitSlashCommand = (text: string): SplitSlashCommand | null => {
   const match = SLASH_COMMAND_SPLIT_RE.exec(text);
   if (!match) return null;
   return {
      before: match[1],
      token: match[2],
      after: text.slice(match[0].length),
   };
};

export interface SlashCommandQuery {
   start: number;
   end: number;
   query: string;
}

/** Complete a whitespace-delimited command while the caret is inside its token. */
export function getSlashCommandQuery(text: string, selectionStart: number, selectionEnd: number): SlashCommandQuery | null {
   if (selectionStart !== selectionEnd) return null;
   const commands = /(^|\s)\/([a-z0-9-]*)(?=\s|$)/gi;
   for (const match of text.matchAll(commands)) {
      const start = match.index + match[1].length;
      const end = match.index + match[0].length;
      if (selectionStart > start && selectionStart <= end) {
         return {start, end, query: match[2]};
      }
   }

   return null;
}
